import { useContext } from 'react';

import type { BackBehaviorOverride } from './BackBehaviorOverride';
import { BackBehaviorOverrideContext } from './BackBehaviorOverrideContext';

export function useBackBehaviorOverride(): BackBehaviorOverride | null {
	return useContext(BackBehaviorOverrideContext).override;
}
